import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("span", {
    class: _normalizeClass(["notification-circle", $options.sizeClass])
  }, _toDisplayString($props.notificationsCounter ? $props.notificationsCounter : ''), 3)]);
}